export const UploadControls = ({ hidden, imageCount, onSelectFiles, onUpload, uploading }) => {
  return (
    <div className={hidden ? 'container-fluid bottom-container mb-3 hide' : 'container-fluid bottom-container mb-3'} id="controls">
      <div className="container">
        <div className="row m-0">
          <div className="col-sm-6 mb-2">
            <input type="file" id="image-input" className="form-control bg-beige" multiple accept="image/*" onChange={onSelectFiles} />
          </div>
          <div className="col-sm-6">
            <button id="upload" className="btn bg-beige w-100" type="button" disabled={!imageCount || uploading} onClick={onUpload}>
              Upload
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

